import Skin from '@/components/Skin/Skin';
import { itemsValue } from '@/utils/itemInfo';
import { InventoryType } from '@/components/MainInventory/MainInventory';
import userStore from '@/stores/user.store';
import WithdrawFooter from '@/components/MainInventory/WithdrawFooter';
import MarketplaceFooter from '@/components/MainInventory/MarketplaceFooter';
import { Dispatch, SetStateAction } from 'react';
import DepositFooter from '@/components/MainInventory/DepositFooter';
import { TSelectedGame } from '@/components/MainInventory/MainInventoryFilter';
import { IBaseItem } from '@/utils/types/Items';
import { cartState } from '@/stores/cart.store';
import InfoSpan from '../InfoSpan/InfoSpan';
import CartIcon from '../DynamicIcons/cart.icon';

export interface CartProps {
    type: InventoryType;
    items: IBaseItem[];
    setSelectedById: cartState['setSelectedById'];
    selectedItemIds: cartState['selectedItemIds'];
    load: () => any;
    setPage: Dispatch<SetStateAction<number>>;
    selectedGame: TSelectedGame;
    mobile?: boolean;
}

const MainCart = ({
    items,
    mobile,
    type,
    setSelectedById,
    selectedItemIds,
    load,
    setPage,
    selectedGame,
}: CartProps) => {
    const total = itemsValue(items?.map((item) => item)).toFixed(2);
    const user = userStore((state) => state.user);

    const footer = () => {
        switch (type) {
            case 'market':
                return (
                    <MarketplaceFooter
                        setPage={setPage}
                        load={load}
                        total={Number(total)}
                        balance={user.balanceUsd}
                        selectedItemIds={selectedItemIds}
                    />
                );
            case 'deposit':
                return (
                    <DepositFooter
                        selectedGame={selectedGame}
                        total={Number(total)}
                        selectedItems={items}
                    />
                );
            case 'withdraw':
                return <WithdrawFooter total={total} />;
        }
    };

    return (
        <div
            className={`rounded xl:w-[365px] h-full ${mobile ? '' : 'max-xl:hidden'} h-dvh bg-gray_three xl:p-4 flex flex-col`}
        >
            <div
                className={
                    'p-3 text-text_gray font-bold gap-2 flex items-center bg-gray w-fit rounded-lg max-xl:hidden'
                }
            >
                <CartIcon color={'#9D9D9D'} />
                CART
            </div>
            <div className={'flex-1 rounded-b flex flex-col overflow-auto'}>
                {type != 'deposit' && (
                    <InfoSpan
                        left={'Your balance: '}
                        className={'w-fit mx-auto xl:mt-8 font-semibold'}
                        right={user.balanceUsd + '$'}
                    />
                )}
                <div
                    className={
                        'overflow-scroll no-scrollbar overflow-x-hidden flex-1 flex gap-2 justify-center flex-wrap content-start my-4'
                    }
                >
                    {items.length > 0 ? (
                        items.map((item) => {
                            return (
                                <div
                                    key={item.id}
                                    onClick={() => setSelectedById(item.id)}
                                    className={'cursor-pointer'}
                                >
                                    <Skin blurOnLoad skin={item} type={'cart'} />
                                </div>
                            );
                        })
                    ) : (
                        <p className={'mx-auto mt-10 text-text_gray max-xl:py-10'}>No items</p>
                    )}
                </div>
                <div className={'border-t border-gray pb-2'}>
                    <InfoSpan
                        left={'Total: '}
                        className={'w-fit mx-auto my-4 font-semibold'}
                        right={'$' + total}
                    />
                    {footer()}
                </div>
            </div>
        </div>
    );
};

export default MainCart;
